import fly from '@/flyio';
declare let process: any;
export default {
    // 获取首页有声听书
    getAudioData(pg: number) {
        const param = { pageSize: pg };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/audio/list", param);
    },
    // 获取首页听书榜
    getAudioRanks(pg: number) {
        const param = { pageSize: pg };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/audio/top10", param);
    }
};
